module.exports = __webpack_public_path__ + "3b845f18749218bd4094dd18aaee900b.png";